
// helper-functions for field types
var fields = {
    text: {
        bindValidationEvents: function(context, validationFunc) {
            var blurred = false;
            var textField = context.querySelector('input');

            if( !textField ) {
                textField = context.querySelector('textarea');
            }
            if( textField ) {
                textField.addEventListener('blur', function() {
                    // console.log("eventlistener added for ",textField.id);
                    if ( blurred == false ) {
                        blurred = true;

                        textField.addEventListener('keyup', function() {
                            validationFunc(context);
                        });
                    }

                    validationFunc(context);
                });

                return true;
            }
            else {
                return false;
            }
        },
        bindRestrictionEvents: function(context, restrictQuery , restrictionFunct) {            
            var restrictElement = context.querySelector(restrictQuery);
            if(restrictElement){
                var textField = context.querySelector('input');

                if( !textField ) {
                    textField = context.querySelector('textarea');
                }
                if( textField ) {
                    textField.addEventListener('change', function() {                        
                        restrictionFunct(textField, restrictElement);
                    });
                    textField.addEventListener('keyup', function() {
                        restrictionFunct(textField, restrictElement);
                    });

                    return true;
                }
            }
            else {
                return false;
            }

        }
    },
    checkbox: {
        bindValidationEvents: function(context, validationFunc) {

        }
    },
    radiobutton: {
        bindValidationEvents: function(context, validationFunc) {
            var blurred = false;
            var radiobuttons = context.querySelectorAll('input[type="radio"]');

            if( radiobuttons.length ) {
                for(var i = 0; i < radiobuttons.length; i++) {
                    radiobuttons[i].addEventListener('click', function() {
                        validationFunc(context);
                    });
                }

                return true;
            }
            else {
                return false;
            }
        }
    }
};


module.exports = {
    fields: fields,
};



// WEBPACK FOOTER //
// ./js-src/markdown-editor/scripts/module-helper.js